import React from 'react';

import classNames from 'classnames';
import DOMPurify from 'isomorphic-dompurify';

const cn = classNames;

const defaultExtraAttributes = ['target'];

export type RichUIProps = {
  code: string;
  extraAttributes?: string[];
  className?: string;
  useRichText?: boolean;
};

const RichUI = ({
  code = '',
  extraAttributes = defaultExtraAttributes,
  className = '',
  useRichText = true,
}: RichUIProps) => {
  const innerHtml = { __html: DOMPurify.sanitize(code, { ADD_ATTR: extraAttributes }) };

  return React.createElement('span', {
    dangerouslySetInnerHTML: innerHtml,
    className: cn(useRichText ? 'rich-text' : '', className),
  });
};

export default RichUI;
